const betaValue = process.env.REACT_APP_BETA ?? process.env.BETA;

export const SERVER_URL = process.env.REACT_APP_SERVER_URL || "";
export const AUTH_URL = process.env.REACT_APP_AUTH_URL || "http://localhost:3045";
export const MESSENGER_URL = process.env.REACT_APP_MESSENGER_URL || "http://localhost:3055";
export const API_BASE_URL = SERVER_URL ? `${SERVER_URL}/api` : "/api";
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
export const IS_BETA = betaValue === "1" || betaValue === "true";
// 450labs shop behind /marketplace. A publishable key is safe in the browser; a server key (hk_srv_) never is.
export const HL_PUBLISHABLE_KEY = process.env.REACT_APP_HL_PUBLISHABLE_KEY || "";
export const HL_API_URL = process.env.REACT_APP_HL_API_URL || "https://api.dev.450labs.net/v1/client";
